// The dashboard shows one timeline at a time: the engagement's main, or the buyer timeline a
// notification link named with ?timeline=. Every badge on the screen names that timeline in its
// code, so viewing the main clears the main's flags and viewing a buyer's clears theirs alone.
export const TIMELINE_QUERY_PARAM = 'timeline';

export const viewedTimelineId = (
    timelineParam: string | null | undefined,
    mainTimelineId: number | undefined
): number | undefined => {
    const requested = timelineParam ? Number(timelineParam) : NaN;
    return Number.isInteger(requested) && requested > 0 ? requested : mainTimelineId;
};

// A buyer without a timeline yet (a non-SFAS buyer who has not engaged) has nothing to drill into:
// the Buyers tab opens the main with a note naming them instead.
export const NOT_ENGAGED_BUYER_QUERY_PARAM = 'notEngaged';
